interface ContactUsEventBody {
  name: string;
  email: string;
  phoneNumber: string;
  message: string;
  recaptchaToken: string;
}

interface LearnMoreSearchRequestBody {
  question: string;
  recaptchaToken: string;
}

export interface LearnMoreSearchSuggestedArticle {
  slug: string;
  title: string;
  relevance?: string;
}

export interface LearnMoreSearchResponse {
  answer: string;
  suggestedArticles: LearnMoreSearchSuggestedArticle[];
}

const openApi: string = import.meta.env.VITE_PLATFORM_API ?? '';
const ApiKey: string = import.meta.env.VITE_PLATFORM_API_KEY ?? '';

export const ContactUs = async (request: ContactUsEventBody) => {
  const response = await fetch(openApi + '/contact-us', {
    method: 'POST',
    headers: {
      'x-api-key': ApiKey,
    },
    body: JSON.stringify(request),
  }).then((data) => {
    if (data.ok && data.status === 200) {
      return data.json();
    } else {
      throw 'non 2xx response';
    }
  });

  return response;
};

export const LearnMoreSearch = async (
  request: LearnMoreSearchRequestBody,
): Promise<LearnMoreSearchResponse> => {
  const response = await fetch(openApi + '/api/learn-more/search', {
    method: 'POST',
    headers: {
      'x-api-key': ApiKey,
    },
    body: JSON.stringify(request),
  }).then((data) => {
    if (data.ok && data.status === 200) {
      return data.json();
    } else {
      throw 'non 2xx response';
    }
  });

  return response;
};
